import { useState } from 'react'
import FamilySOS from './FamilySOS'
import { Menu, Bell, Search, User } from 'lucide-react'
import { useDemo } from '../contexts/DemoContext'
import { useContext } from 'react'
import { FamilyContext } from '../contexts/FamilyContext'
import { useNotifications } from '../contexts/NotificationContext'
import { useI18n } from '../hooks/useI18n'

const Header = ({ onMenuClick }) => {
  const { profile, user, signOut } = useDemo()
  const { family } = useContext(FamilyContext)
  const { unreadCount } = useNotifications()
  const { t, lang, setLang } = useI18n()
  const [showUserMenu, setShowUserMenu] = useState(false)

  return (
    <header className="bg-white shadow-sm border-b border-neutral-200">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          {/* Left side */}
          <div className="flex items-center">
            <button
              type="button"
              className="lg:hidden rounded-md p-2 text-neutral-400 hover:bg-neutral-100 hover:text-neutral-500"
              onClick={onMenuClick}
            >
              <Menu className="h-6 w-6" />
            </button>
            
            <div className="ml-4 lg:ml-0">
              <h1 className="text-xl font-semibold text-neutral-900">
                {t('brand')}
              </h1>
              <p className="text-sm text-neutral-500">
                {t('header.subtitle')}
              </p>
            </div>
          </div>

          {/* Center - Search */}
          <div className="flex-1 max-w-lg mx-4 hidden sm:block">
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Search className="h-5 w-5 text-neutral-400" />
              </div>
              <input
                type="text"
                placeholder="Pesquisar..."
                className="block w-full pl-10 pr-3 py-2 border border-neutral-300 rounded-lg leading-5 bg-white placeholder-neutral-500 focus:outline-none focus:placeholder-neutral-400 focus:ring-1 focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
              />
            </div>
          </div>

          {/* Right side */}
          <div className="flex items-center space-x-4">
            <FamilySOS />
            {/* Language switcher */}
            <div className="hidden sm:flex items-center space-x-1">
              {['pt','en','es'].map(code => (
                <button
                  key={code}
                  onClick={() => setLang(code)}
                  className={`px-2 py-1 rounded text-xs border ${lang===code ? 'bg-primary-50 text-primary-700 border-primary-200' : 'text-neutral-600 border-neutral-200 hover:bg-neutral-50'}`}
                  title={code.toUpperCase()}
                >
                  {code.toUpperCase()}
                </button>
              ))}
            </div>
            {/* Notifications */}
            <button className="relative rounded-full p-2 text-neutral-400 hover:bg-neutral-100 hover:text-neutral-500">
              <Bell className="h-6 w-6" />
              {unreadCount > 0 && (
                <span className="absolute -top-1 -right-1 h-4 w-4 rounded-full bg-primary-500 text-xs text-white flex items-center justify-center">
                  {unreadCount > 99 ? '99+' : unreadCount}
                </span>
              )}
            </button>

            {/* User menu */}
            <div className="relative">
              <button
                className="flex items-center space-x-3 rounded-lg p-2 text-sm hover:bg-neutral-100"
                onClick={() => setShowUserMenu(!showUserMenu)}
              >
                <div className="h-8 w-8 rounded-full bg-primary-500 flex items-center justify-center">
                  <User className="h-5 w-5 text-white" />
                </div>
                <div className="hidden sm:block text-left">
                  <p className="font-medium text-neutral-900">
                    {profile?.display_name || profile?.full_name || user?.displayName || 'Usuário'}
                  </p>
                  <p className="text-xs text-neutral-500">
                    {family?.role === 'admin' ? 'Master' : family ? 'Membro' : 'Família não configurada'}
                  </p>
                </div>
              </button>

              {/* Dropdown menu */}
              {showUserMenu && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-neutral-200 py-1 z-50">
                  <a
                    href="/profile"
                    className="block px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-100"
                  >
                    Meu Perfil
                  </a>
                  <a
                    href="/settings"
                    className="block px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-100"
                  >
                    Configurações
                  </a>
                  <div className="border-t border-neutral-200 my-1"></div>
                  <button
                    onClick={signOut}
                    className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50"
                  >
                    Sair
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header


